<mat-form-field class="w-100" [hideRequiredMarker]="!attributeDefinition.isRequired">
  <mat-label>
    {{ label }}
  </mat-label>
  <input matInput [id]="attributeDefinition.formControlName" [formControl]="control" />
  <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>